import { useParams } from "react-router-dom";
import { useGetTicketLogDetailsQuery } from "../../../../../features/superAdmin/ticketService/ticket/ticket.api";
import SidebarLayout from "../../../../../layouts/SidebarLayout";

import { TicketDetails as TicketDetailsType } from "../../../../../features/superAdmin/ticketService/ticket/ticket.type";
import DetailsSpecification from "./_components/DetailsSpecification";
import TicketDetailsHeader from "./_components/TicketDetailsHeader";
import TicketDetailsTabs from "./_components/TicketDetailsTabs";
import TicketDetailsTitleDesc from "./_components/TicketDetailsTitleDesc";

const LogTicketDetails = () => {
  const { id } = useParams();
  const { data: detailsResponse } = useGetTicketLogDetailsQuery({
    params: { id: id as string, emp_id: "" },
  });
  const ticketDetails = (detailsResponse?.data || {}) as TicketDetailsType;

  return (
    <SidebarLayout title="Ticket Management">
      <TicketDetailsHeader></TicketDetailsHeader>
      <div className="grid grid-cols-5 gap-4">
        <div className="col-span-3">
          <TicketDetailsTitleDesc ticket={ticketDetails} />
          <DetailsSpecification ticket={ticketDetails} />
        </div>
        <div className="col-span-2">
          <TicketDetailsTabs ticketDetails={ticketDetails} />
        </div>
      </div>
    </SidebarLayout>
  );
};

export default LogTicketDetails;
